import { render, staticRenderFns } from "./wxBuy.vue?vue&type=template&id=783d07b1&scoped=true&"
import script from "./wxBuy.vue?vue&type=script&lang=js&"
export * from "./wxBuy.vue?vue&type=script&lang=js&"
import style0 from "./wxBuy.vue?vue&type=style&index=0&id=783d07b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d07b1",
  null
  
)

export default component.exports